import { staticText } from '../../utils/translations/staticText';

export const baseTranslations = {
  progress: {
    _: 'Progress',
  },
  progress_steps: {
    _: 'Progress steps',
  },
  step: {
    _: 'STEP',
  },
};

export const TRANSLATIONS = staticText(baseTranslations);

export type ProgressStepperTranslationKey = keyof typeof baseTranslations;
